import { InputTypes } from "../../data-parsing/InputTypes";
import MobilePreviewPopUp from "../mobilePreview/MobilePreviewPopUp";
import { Link } from "react-router-dom";
import React from "react";

export function ClickableInput(props) {
  const { hasChanged, dataTemplate, ...other } = props;
  switch (props?.type) {
    case InputTypes.DELETE:
      return (
        <button
          name={props.name}
          className="btn btn-danger pull-right"
          data-toggle="tooltip"
          {...other}
        >
          <i className="far fa-trash-alt"></i>
        </button>
      );
    case InputTypes.SAVE:
      return (
        hasChanged && (
          <button
            name={props.name}
            className="btn pull-right m-10"
            data-toggle="tooltip"
            {...other}
          >
            <i className="far fa-save"></i>
          </button>
        )
      );
    case InputTypes.PREVIEW:
      return (
        <MobilePreviewPopUp
          trigger={
            <button name={props.name} className="btn" data-toggle="tooltip">
              <i className="far fa-image"></i>
            </button>
          }
          dataTemplate={dataTemplate}
          {...other}
        ></MobilePreviewPopUp>
      );
    case InputTypes.REDIRECT:
      return (
        <Link to={`${props.data?._id}`} style={{ color: "#71b6f9" }}>
          <span>Detalles</span>
        </Link>
      );
    case InputTypes.VIDEOCALL:
      /*       console.log("props", props);
      console.log("onclick", props.videocallCallback); */
      return (
        <Link to={`${props.data?.user_id}`}>
          <button
            name={props.name}
            className="btn btn-info"
            data-toggle="tooltip"
            {...other}
            /*             onClick={props.videocallCallback(props.data._id)}
             */
          >
            <i className="fas fa-phone"></i>
          </button>
        </Link>
      );
  }
}
